/* oddit-section-sticky-atc — show only between the main add-to-cart and the footer */

(function () {
  var SECTION_SEL = '.oddit-section-sticky-atc';
  // The wrapper, not the button: the main product section replaces the button's markup
  // on every variant change, which would leave the observer watching a detached node.
  var MAIN_ATC_SEL = '[data-buy-buttons]';
  var FOOTER_SEL = '.shopify-section-group-footer-group';

  function init(root) {
    if (!root || !window.IntersectionObserver) return;

    var mainAtc = document.querySelector(MAIN_ATC_SEL);
    var footerSections = document.querySelectorAll(FOOTER_SEL);
    if (!mainAtc) return;

    var pastMainAtc = false;
    var visibleFooterSections = 0;

    function update() {
      root.classList.toggle('is-visible', pastMainAtc && visibleFooterSections === 0);
    }

    new IntersectionObserver(
      function (entries) {
        var entry = entries[entries.length - 1];
        // Scrolled below it, not still approaching it from above.
        pastMainAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      },
      { threshold: 0 }
    ).observe(mainAtc);

    if (footerSections.length) {
      var footerObserver = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            visibleFooterSections += entries[i].isIntersecting ? 1 : -1;
          }
          if (visibleFooterSections < 0) visibleFooterSections = 0;
          update();
        },
        { threshold: 0 }
      );
      for (var f = 0; f < footerSections.length; f++) {
        footerObserver.observe(footerSections[f]);
      }
    }
  }

  var section = document.querySelector(SECTION_SEL);
  if (section) init(section);

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector && e.target.querySelector(SECTION_SEL);
    if (s) init(s);
  });
})();
